<template>
  <div class="component-enotas">
    <h4 class="text-semibold mb-5">eNotas</h4>
    <snow-data-table-header
      class="mb-6"
      @add="add"
      @searching="searching"
      :datePicker="false"
      :filters="false"
    />
    <div v-if="loading" class="text-center">
      <b-spinner variant="primary" />
    </div>
    <div v-else>
      <div
        v-if="!integrationList.length"
        class="container centralize-row text-center pt-5"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5">
            <img
              class="d-block my-9 mx-auto"
              src="@/assets/images/no-content.svg"
            />
            <h5>Você ainda não adicionou nenhuma integração</h5>
            <div class="text-secondary mb-5">
              Clique no botão acima para cadastrar
            </div>
          </div>
        </div>
      </div>
      <!-- Desktop area -->
      <snow-data-table
        v-else
        :columns="InvoicesColumns"
        :data="integrationList"
      />
      <!-- Mobile area -->
      <div class="d-flex justify-content-end mt-4">
        <snow-paginator
          v-model="page"
          :pagination="pagination"
          @change-page="dispatch"
        />
      </div>
    </div>
    <enotas-modal
      v-model="modal"
      :integrationToEdit="integrationToEdit"
      @clear-edit="integrationToEdit = null"
      @update-list="dispatch"
    />
  </div>
</template>
<script>
import enotasModal from "@/components/tools/modals/ENotas.vue";
import IntegrationsMixin from "@/mixins/integration.js";
import get from "lodash/get";
import { mapState } from "vuex";
export default {
  mixins: [IntegrationsMixin],
  components: {
    enotasModal
  },
  mounted() {
    this.$store.commit("integration/setIntegration", this.integration);
    this.dispatch();
  },
  data() {
    return {
      integration: "enotas",
      integrationToEdit: null,
      nfeOptions: [
        "Emitir nota no ato da venda",
        "Emitir nota depois quando garantia acabar",
        "Não emitir a nota"
      ],
      loading: false,
      modal: false,
      search: ""
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    ...mapState("integration", ["integrationList", "pagination"]),
    InvoicesColumns() {
      return [
        {
          name: "Produto",
          field: "product_id",
          transform: item => this.productName({ product_id: item })
        },
        {
          name: "Quando emitir nota",
          field: "when_generate_nfe",
          transform: value => this.nfeOptions[value]
        },
        {
          name: "Token",
          field: "token"
        },
        {
          name: "Envio ao cliente",
          field: "send_nfe_for_client",
          transform: value => (value ? "Sim" : "Não")
        },
        {
          name: "Divisão ao coprodutor",
          field: "is_split",
          transform: value => (value ? "Sim" : "Não")
        },
        {
          name: "Status",
          field: "is_enable",
          transform: value => (value ? "Ativo" : "Inativo"),
          color: value => (value ? "green" : "negative"),
          type: "tag"
        },
        {
          name: "",
          type: "menu",
          options: this.getActions
        }
      ];
    }
  },
  methods: {
    getStatusColor(status) {
      const colorMap = {
        enable: "text-success",
        review: "text-warning",
        disable: "text-danger",
        fail: "text-danger"
      };
      return colorMap[status];
    },
    getStatusMessage(status) {
      const messageMap = {
        enable: "Ativo",
        review: "Em revisão",
        disable: "Inativo",
        fail: "Token inválido"
      };
      return messageMap[status];
    },
    productName(item) {
      return get(
        this.products.find(p => p.id === item.product_id),
        "name",
        "-"
      );
    },
    getActions(item) {
      return [
        {
          label: item.is_enable ? "Desativar" : "Ativar",
          class: item.is_enable ? "text-danger" : "text-success",
          click: this.changeStatus
        },
        {
          label: "Editar",
          click: this.edit
        },
        {
          label: "Excluir",
          class: "text-danger",
          variant: "danger",
          dialog: {
            text: "Tem certeza que deseja excluir esta integração?",
            buttonText: "Confirmar",
            secondaryButtonText: "Cancelar",
            variant: "negative",
            icon: "ph ph-trash",
            action: this.submitDelete
          }
        }
      ];
    },
    dispatch() {
      this.$store.dispatch("product/get", { limit: 500 });

      let params = { search: this.search };

      this.loading = true;
      this.$store
        .dispatch("integration/getIntegration", params)
        .catch(error => {
          this.$message.error("Não foi possível carregar as contas integradas");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeStatus(item) {
      let data = item;
      data.is_enable = !item.is_enable;
      this.$store
        .dispatch("integration/putIntegration", data)
        .then(() => {
          this.$message.success(
            `Integração ${data.is_enable ? "ativada" : "desativada"}`
          );
        })
        .catch(() => {
          this.$message.error(
            "Não foi possível alterar o status da integração"
          );
        });
    }
  }
};
</script>
<style></style>
